<div *nzModalTitle></div>
<div class="modal-content">
  @if (isLoading()) {
    <korviu-loader></korviu-loader>
  }
  <i nz-icon class="mb-4 lg:mb-6 sm:mb-4">
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
      <path
        d="M20 29.9999C20.5667 29.9999 21.0417 29.8082 21.425 29.4249C21.8083 29.0416 22 28.5666 22 27.9999C22 27.4332 21.8083 26.9582 21.425 26.5749C21.0417 26.1916 20.5667 25.9999 20 25.9999C19.4333 25.9999 18.9583 26.1916 18.575 26.5749C18.1917 26.9582 18 27.4332 18 27.9999C18 28.5666 18.1917 29.0416 18.575 29.4249C18.9583 29.8082 19.4333 29.9999 20 29.9999ZM18 21.9999H22V9.9999H18V21.9999ZM20 39.9999C17.2333 39.9999 14.6333 39.4749 12.2 38.4249C9.76667 37.3749 7.65 35.9499 5.85 34.1499C4.05 32.3499 2.625 30.2332 1.575 27.7999C0.525 25.3666 0 22.7666 0 19.9999C0 17.2332 0.525 14.6332 1.575 12.1999C2.625 9.76657 4.05 7.6499 5.85 5.8499C7.65 4.0499 9.76667 2.6249 12.2 1.5749C14.6333 0.524901 17.2333 -9.91821e-05 20 -9.91821e-05C22.7667 -9.91821e-05 25.3667 0.524901 27.8 1.5749C30.2333 2.6249 32.35 4.0499 34.15 5.8499C35.95 7.6499 37.375 9.76657 38.425 12.1999C39.475 14.6332 40 17.2332 40 19.9999C40 22.7666 39.475 25.3666 38.425 27.7999C37.375 30.2332 35.95 32.3499 34.15 34.1499C32.35 35.9499 30.2333 37.3749 27.8 38.4249C25.3667 39.4749 22.7667 39.9999 20 39.9999Z"
        fill="#F28334"
      />
    </svg>
  </i>
  <span class="font-bold modal-title mb-6 sm:mb-6 lg:mb-8">{{ 'profile.removeAccount' | translate }}</span>
  <span class="font-light text-lg text-center">{{ 'profile.areYouSureYouWantToRemove' | translate }}</span>
</div>
<div *nzModalFooter>
  <div class="flex flex-row gap-2 md:gap-4">
    <korviu-button class="flex-1" color="ghost" size="small" (click)="onBackClick()">
      {{ 'common.back' | translate }}
    </korviu-button>
    <korviu-button class="flex-1" color="tertiary" size="small" (click)="onRemoveClick()">
      {{ 'profile.remove' | translate }}
    </korviu-button>
  </div>
</div>
